// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".section-container[data-v-795c3eac] {\n  margin-top: 2rem;\n}\n[data-v-795c3eac] .section-container__text-area .small-counter {\n  font-size: 0.8rem;\n  color: #727272;\n}", ""]);
// Exports
module.exports = exports;
